import { api } from "../../lib/api";
import { toast } from "sonner";

export async function downloadReport(path, filename, params = {}) {
  try {
    const res = await api.get(path, { params, responseType: "blob" });
    const blob = new Blob([res], { type: res.type || "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error("Export failed — please retry");
  }
}
